import superagent from 'superagent'
import isNil from 'lodash/isNil'

export const residenceSet = residences => ({
  type: 'RESIDENCES_SET',
  payload: residences
})

export const residenceLogout = () => ({
  type: 'RESIDENCE_LOGOUT',
  payload: []
})

export const residenceGetRequest = () => (dispatch, getState) => {
  const residences = getState().residences
  return !isNil(residences) && residences.length > 0 ? Promise.resolve(residences) :
    new Promise(resolve => {
      superagent
        .get(`${__API_URI__}/state/get/`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            if (err.status == 401) {
              return err.status
            }
          }

          resolve(res.body)
          dispatch(residenceSet(res.body))
          return
        })
    })
}
